import { render, staticRenderFns } from "./WhyRedModal.vue?vue&type=template&id=0199546e&scoped=true&"
import script from "./WhyRedModal.vue?vue&type=script&lang=js&"
export * from "./WhyRedModal.vue?vue&type=script&lang=js&"
import style0 from "./WhyRedModal.vue?vue&type=style&index=0&id=0199546e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0199546e",
  null
  
)

export default component.exports